// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__YnoPb","text":"logo_text__13AmC","white":"logo_white__38IO3","black":"logo_black__1IFLq"};